module.exports = __webpack_public_path__ + "img/lander-action-01.de854330.webp";